export type AgencyFeeView = {
  id: number;
  name: string;
  price: number;
  currencyId?: number;
  calculationMethodId: number;
  priceIsAbsolute: boolean;
};

export class AgencyFeeModel {
  id = 0;
  name = "";
  price = 0;
  currencyId = null as number | null;
  calculationMethodId = 0;
  priceIsAbsolute = false;
  amount = 0;

  translations = [] as AgencyFeeTranslation[];
  
  propertyIds = [] as number[];
  agencyFeesProperties = [] as AgencyFeesPropertyModel[];
}

export class AgencyFeeViewModel {
  agencyFeeId = 0;
}

export class AgencyFeeRequestModel {
  id = 0;
  price = 0;
}

export class AgencyFeeTranslation {
  id = 0;
  agencyFeeId = 0;
  cultureCode = "";
  translation = "";
}

export class AgencyFeesPropertyModel {
  id = 0;
  agencyFeeId = 0;
  propertyId = 0
  name = "";
  price = 0;
  currencyId = null as number | null;
  calculationMethodId = 0;
  priceIsAbsolute = false;
  isAssigned = false;
}

export class AgencyFeesPropertyRequest {
  propertyId = 0;
  updateReservations = false;
  agencyFeesProperty = [] as AgencyFeeRequestModel[];
}
